<ng-container *ngIf="view$ | async as view; else empty">
  <ul class="native-tab__lines">
    <li *ngFor="let item of view.cart.items" class="native-tab__line">
      <div class="native-tab__line-image">
        <img
          *ngIf="item.price_data?.product_data?.images?.length"
          [src]="item.price_data.product_data.images[0]"
          [alt]="item.price_data.product_data.name"
        />
      </div>
      <div class="native-tab__line-info">
        <p class="native-tab__line-title">{{ item.price_data?.product_data?.name }}</p>
        <p class="native-tab__line-meta">
          <span>Qty: {{ item.quantity }}</span>
          <span>{{ (item.price_data.unit_amount ?? 0) * item.quantity | currency }}</span>
        </p>
      </div>
    </li>
  </ul>

  <footer class="native-tab__footer">
    <div class="native-tab__subtotal">
      <span>Subtotal</span>
      <strong>{{ view.subtotal | currency }}</strong>
    </div>
    <a
      nbButton
      status="primary"
      size="large"
      fullWidth
      routerLink="/shop/cart"
      class="native-tab__view-cart"
    >
      View cart →
    </a>
  </footer>
</ng-container>

<ng-template #empty>
  <div class="native-tab__empty">
    <nb-icon icon="shopping-cart-outline" class="native-tab__empty-icon"></nb-icon>
    <p class="native-tab__empty-text">Your Russell's cart is empty</p>
    <a routerLink="/shop" class="native-tab__empty-link">Browse Russell's →</a>
  </div>
</ng-template>
